import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({ selector: '[mcEditorToolbarItem]' })
export class EditorToolbarItemDirective {
    // tslint:disable-next-line:no-input-rename
    @Input('mcEditorToolbarItem') templateName: string;
    constructor(public templateRef: TemplateRef<any>) { }
}
